import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const HyperlinkIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.312 13.312"
      height={getDefaultHeight(svgProps, 13.312)}
      {...svgProps}
    >
      <g
        fill="none"
        stroke={color ?? "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path d="M6.938 11.007a3.177 3.177 0 01-4.214 1.518h0a3.177 3.177 0 01-1.518-4.214l.963-2.044a3.176 3.176 0 014.214-1.521h0a3.166 3.166 0 011.75 2.224" />
        <path d="M6.374 2.724a3.177 3.177 0 014.215-1.517h0a3.177 3.177 0 011.518 4.214l-.963 2.047A3.177 3.177 0 016.93 8.986h0a3.159 3.159 0 01-1.64-1.827" />
      </g>
    </SVG>
  );
};
